<template>
  <horiz-field :horizontal="false">
    <slot name="label" slot="label"></slot> <slot></slot>
    <slot name="icon" slot="icon"></slot>
  </horiz-field>
</template>

<script>
import HorizField from "./HorizField";
export default {
  name: "VerticalField",
  components: { HorizField }
};
</script>
